import { render } from "./Problem_identification.vue?vue&type=template&id=72732f42&scoped=true"
import script from "./Problem_identification.vue?vue&type=script&lang=js"
export * from "./Problem_identification.vue?vue&type=script&lang=js"

import "./Problem_identification.vue?vue&type=style&index=0&id=72732f42&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-72732f42"]])

export default __exports__